// extracted by mini-css-extract-plugin
export default {"content":"service-confirm-moda_content__YuHhD","buttons":"service-confirm-moda_buttons__0lyaG"};